import EscapeManager from '../../../js/Managers/EscapeManager.js';
import SizeUtility from '../../../js/Utilities/SizeUtility.js';

class SiteHeader extends HTMLElement {
  escapeManagerID = null;
  dialog = null;
  buttonOpen = null;
  buttonClose = null;
  meganavs = [];

  constructor() {
    super();

    this.escapeManagerID = 'site-header';

    this.dialog = this.querySelector('.header__nav');
    this.buttonOpen = this.querySelector('.header-nav__button');
    this.buttonClose = this.querySelector('.header-nav__close');

    this.meganavs = [...this.querySelectorAll('.mega-nav')];

    this._onButtonClick = this.onButtonClick.bind(this);
    this._onDialogClose = this.onDialogClose.bind(this);
    this._onDialogBackDropClick = this.onDialogBackDropClick.bind(this);
    this._onWindowResize = this.onWindowResize.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();

    this.onWindowResize();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.buttonOpen.addEventListener('click', this._onButtonClick);
    this.buttonClose.addEventListener('click', this._onButtonClick);

    this.dialog.addEventListener('close', this._onDialogClose);
    this.dialog.addEventListener('click', this._onDialogBackDropClick);

    window.addEventListener('resize', this._onWindowResize);
    window.addEventListener('scroll', this._onWindowResize);
  }

  removeEventListeners() {
    this.buttonOpen.removeEventListener('click', this._onButtonClick);
    this.buttonClose.removeEventListener('click', this._onButtonClick);
    this.dialog.removeEventListener('close', this._onDialogClose);
    this.dialog.removeEventListener('click', this._onDialogBackDropClick);
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('scroll', this._onWindowResize);
  }

  onButtonClick() {
    this.toggle();
  }

  get open() {
    return this.dialog?.open || false;
  }
  set open(value) {
    if (value) {
      this.openContainer();
    } else {
      this.closeContainer();
    }
  }

  openContainer() {
    this.buttonOpen.setAttribute('aria-expanded', 'true');
    if (this.dialog && !this.dialog.open) {
      this.dialog.showModal();
      this.onDialogOpen();
    }
  }
  closeContainer() {
    this.buttonOpen.setAttribute('aria-expanded', 'false');

    if (this.dialog && this.dialog.open) {
      this.dialog.close();
    }
  }
  toggle() {
    this.open = !this.open;
  }

  onWindowResize() {
    if (SizeUtility.isScreenGtLg() && this.dialog.open) {
      this.dialog.close();
    }
  }

  onDialogOpen() {
    EscapeManager.add(this.escapeManagerID, () => this.onEscapeKey());
  }
  onDialogClose() {
    EscapeManager.remove(this.escapeManagerID);
  }

  onDialogBackDropClick(event) {
    if (!this.open) return;
    var rect = this.dialog.getBoundingClientRect();
    var isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      this.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;
    if (!isInDialog && event.target.tagName === 'DIALOG') {
      this.dialog.close();
    }
  }

  onEscapeKey() {
    if (this.dialog.open) {
      this.dialog.close();
    }
  }
}

customElements.define('site-header', SiteHeader);
